import { useState } from 'react';
import styles from './Input.module.css';
import { useTranslation } from 'react-i18next';
import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';

function Input({
    type = 'text',
    error,
    placeholder,
    value,
    onChange,
    name,
    id,
    required = false,
    disabled = false,
    className = ''
}) {
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === 'password';
    const inputType = isPassword && showPassword ? 'text' : type;
    const inputWrapperMain = `${styles.inputWrapper} ${className}`.trim();
    const inputClasses = `${styles.input} ${error ? styles.inputError : ''} ${isPassword ? styles.inputWithIcon : ''}`.trim();
    const { t } = useTranslation('validation');
    const CODE_MAP = {
        'string.min': 'field_required',
        'string.invalid': 'field_required',
        'date.invalid': 'date_invalid',
        'email.invalid': 'validation.email.invalid',
    };
    let errorMessage = null;
    if (error) {
        const rawCode = error.code ?? '';
        const stripped = rawCode.startsWith('validation.') ? rawCode.slice('validation.'.length) : rawCode;
        const minValue = error.params?.min ?? error.params?.minimum;
        const useCodeMap = CODE_MAP[stripped] && (stripped !== 'string.min' || !minValue || minValue <= 1);
        const code = useCodeMap ? CODE_MAP[stripped] : stripped.includes('.') ? rawCode : stripped;
        if (error.params && !useCodeMap) {
            const entries = Object.entries(error.params);
            const paramValue = entries.length > 0 ? entries[0][1] : undefined;
            errorMessage = t(code, { toReplace: paramValue });
        } else {
            errorMessage = t(code);
        }
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className={inputWrapperMain}>
            <div className={styles.inputContainer}>
                <input
                    type={inputType}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    name={name}
                    id={id}
                    required={required}
                    disabled={disabled}
                    className={inputClasses}
                />
                {isPassword && (
                    <button
                        type="button"
                        className={styles.eyeButton}
                        onClick={togglePasswordVisibility}
                        disabled={disabled}
                        aria-label={!showPassword ? 'Hide password' : 'Show password'}
                    >
                        {!showPassword ? (
                            <IoEyeOffOutline className={styles.eyeIcon} />
                        ) : (
                            <IoEyeOutline className={styles.eyeIcon} />
                        )}
                    </button>
                )}
            </div>
            {error && <p className={styles.errorText}>{errorMessage}</p>}
        </div>
    );
}

export default Input;
